export const blockIconsMapsHomePinNew = (
	<span className='material-symbols-outlined'>home_pin</span>
);
